import useJsonApi from "lib/useJsonApi.js";

function useAppointmentPhotos(appointmentUuid) {
  return useJsonApi({
    url: `/api/appointment/${encodeURIComponent(appointmentUuid)}/photos`,
  });
}

export default useAppointmentPhotos;
